import React from "react";
import styles from "./styles/CoreValues.module.css";

export default function CoreValues() {
  const values = [
    {
      title: "SIMPLICITY",
      description: "Working with ease and transparency.",
    },
    {
      title: "INNOVATION",
      description: "Passion for automation and innovation.",
    },
    {
      title: "PARTNERSHIP",
      description: "Mutual trust with utmost integrity.",
    },
    {
      title: "RESPECT",
      description: "Treat everyone with respect.",
    },
  ];

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <h2 className={styles.heading}>Core Values</h2>
        <p className={styles.intro}>
          We are a company driven by passion powered by our core values, our guiding light that helps us
          make the right, moral, brilliant and most simple decision when faced with a perplexing situation.
        </p>
        <div className={styles.gridFour}>
          {values.map((item, index) => (
            <div key={index} className={styles.card}>
              <span className={styles.iconCircle} aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" width="28" height="28">
                  <path d="M12 2l3 6 6 1-4 4 1 6-6-3-6 3 1-6-4-4 6-1z" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
              <h3 className={styles.cardTitle}>{item.title}</h3>
              <p className={styles.cardText}>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
